export const EditIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#191919"
      d="M10.8637 3.6194L3.79402 10.6889C3.5168 10.9672 3.33672 11.3275 3.28052 11.7162L3.01239 13.5928C2.98746 13.7673 3.00025 13.9452 3.04988 14.1143C3.09951 14.2834 3.18484 14.44 3.3001 14.5733C3.41537 14.7067 3.55789 14.8138 3.71807 14.8874C3.87824 14.961 4.05233 14.9994 4.2286 15C4.28825 15 4.34782 14.9958 4.40686 14.9873L6.28322 14.7195C6.67207 14.6631 7.03241 14.4829 7.31082 14.2057L14.3808 7.13613C14.7774 6.7383 15.0001 6.19945 15 5.63771C14.9999 5.07596 14.7772 4.53715 14.3805 4.1394L13.8605 3.61911C13.4626 3.22258 12.9237 2.99994 12.362 3C11.8003 3.00006 11.2615 3.22279 10.8637 3.6194ZM6.45468 13.3495C6.36193 13.4419 6.24187 13.5018 6.11234 13.5204L4.21086 13.7643L4.47929 11.8874C4.49792 11.7579 4.55784 11.6378 4.65016 11.5451L9.62366 6.57195L11.428 8.37628L6.45468 13.3495ZM13.5243 6.28001L12.2842 7.52015L10.4798 5.71581L11.7198 4.47582C11.8902 4.30569 12.1212 4.21011 12.362 4.21006C12.6028 4.21 12.8338 4.30547 13.0043 4.47553L13.524 4.99553C13.6941 5.16599 13.7896 5.39692 13.7897 5.63771C13.7898 5.87849 13.6943 6.10948 13.5243 6.28001Z"
    />
  </svg>
);
